import React from 'react';
import Navigation from '../components/Navigation';
import '../styles/LandingPage.css';

function Contact() {
  return (
    <div className="page">
      <Navigation />
      <div className="content">
        <h1>Contact</h1>
        <h3><a className='link' target='_blank' rel="noreferrer" href="https://www.instagram.com/loveyoubyeband/">Click Here</a></h3>
        {/* Add unique About page content here */}
      </div>
    </div>
  );
}

export default Contact;